/**
 * Button types
 */
export enum ButtonType {
    Action = 'action',
    Link = 'link',
    Submit = 'submit',
}
